
<template>
<v-content>
        <v-card flat>
            <v-card-title>
                Results for {{ActiveSearch}}...
            </v-card-title>
            <v-card-text>

            <v-expansion-panels focusable>
                <v-expansion-panel
                    v-for="result in FinalResults" :key="result.itemObjKey"
                >
                <v-expansion-panel-header>{{result.Origin}}<v-icon>{{result.Icon}}</v-icon>  Results ({{result.Array.length}})</v-expansion-panel-header>
                <v-expansion-panel-content>
                    <v-list v-for="single in result.Array" :key="single.itemObjKey">
                            <v-list-item>
                                <v-list-item-content>
                                {{single[result.Prop]}}
                                </v-list-item-content>
                                <v-list-item-content>
                                    <v-btn fab icon :href="single.Path"><v-icon>mdi-database</v-icon></v-btn>
                                </v-list-item-content>
                                 <v-list-item-content v-if="single.WikiPath">
                                    <v-btn fab icon :href="single.WikiPath"><v-icon>mdi-wikipedia</v-icon></v-btn>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
                         
            </v-card-text>
        </v-card>
    </v-content>
</template>

<script>
import firebase from 'firebase';
import db from '@/main'
import router from '@/router/index.js'
import { setTimeout } from 'timers'

export default {
    props: ['ActiveSearch'],
    data() {
        return{
        usersresult: [],
           items: [
        {
          text: 'Welcome',
          disabled: false,
          href: '/Welcome',
        },
      ],
      defaultitems: [
        {
          text: 'Welcome',
          disabled: false,
          href: '/Welcome',
        },
      ],
        }
    },

    computed: {
        FinalResults(){
            let arr = []
            if(this.usersresult.length > 0){
                let UserObj = {
                    Origin: 'Users',
                    Icon: 'mdi-face',
                    Prop: 'Full_Name',
                    Array: this.usersresult.map(result => {
                        result.Path = '/User/'+result.id
                        return result
                    })
                }
                //console.log('UserObj',UserObj)
                arr.push(UserObj)
            }
            return arr
        },
    },


    watch:{
        'ActiveSearch' (){
            this.GetNavigation()
        }
    },

    created() {
        this.GetNavigation()
    },
    methods: {

       GetNavigation: function (){
           console.log('it changed')

           this.items = Object.assign([],this.defaultitems)
          setTimeout(() => {

        let checkingurl = this.$route.path
         console.log(checkingurl)
              db.collection('users').where('Full_NameQuery','array-contains',this.ActiveSearch.toLowerCase()).onSnapshot(res => {
                this.usersresult = []
                    const changes = res.docChanges();
                    changes.forEach(change => {
                        if (change.type === 'added') {
                        this.usersresult.push({
                            ...change.doc.data(),
                            id: change.doc.id
                        })
                        }


                    })
                    })
           
           

        }, 500)
       }
       }
    }

</script>

<style>
.fixed {
position: fixed;
}
</style>
    